// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-ledger-review {
  background: #ffffff;
  min-height: calc(100vh - 184px);
  padding: 16px 24px 32px;
}
.agent-ledger-review .details-header {
  padding: 10px 24px;
  background: #f0f4f7;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.agent-ledger-review .details-header .header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.agent-ledger-review .details-header .header-title {
  font-size: 16px;
  font-weight: 700;
  color: #637f92;
}
.agent-ledger-review .ant-collapse {
  border: none;
  background: transparent;
}
.agent-ledger-review .ant-collapse > .ant-collapse-item {
  border: none !important;
  background: #fff;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
}
.agent-ledger-review .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  height: 40px !important;
  background: #f0f4f7 !important;
  border: none !important;
  font-weight: 700 !important;
  font-size: 16px;
  line-height: 16px !important;
  color: #637f92 !important;
  padding: 12px 24px;
  display: flex;
  align-items: center;
}
.agent-ledger-review .ant-collapse > .ant-collapse-item .ant-collapse-arrow {
  border: 1px solid #637f92;
  background: #637f92;
  border-radius: 50%;
  color: white !important;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px !important;
}
.agent-ledger-review .ant-collapse > .ant-collapse-item > .ant-collapse-content {
  border: none !important;
  background: #fff;
}
.agent-ledger-review .ant-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding: 20px 24px;
  border: 1px solid #f0f4f7;
  margin-top: 10px;
}
.agent-ledger-review .panel-content .info-label {
  color: #637f92;
  font-size: 13px;
  margin-bottom: 4px;
}
.agent-ledger-review .panel-content .info-value {
  color: #2c3e50;
  font-size: 15px;
  font-weight: 600;
  word-break: break-word;
}
.agent-ledger-review .review-split {
  display: flex;
  gap: 20px;
  align-items: stretch;
}
.agent-ledger-review .review-decision-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0 0 14px;
}
.agent-ledger-review .review-decision-header .section-heading {
  flex: 0 0 auto;
  margin: 0;
}
.agent-ledger-review .review-options {
  flex: 1 1;
  display: flex;
  align-items: stretch;
  gap: 10px;
}
.agent-ledger-review .review-option {
  flex: 0 1 auto;
  min-width: 0;
  text-align: center;
  background: #fff;
  border: 1px solid #e6edf2;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  line-height: 18px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.agent-ledger-review .review-option:hover {
  border-color: #637f92;
}
.agent-ledger-review .review-option.is-active {
  border-color: #637f92;
  background: #f0f4f7;
  box-shadow: 0 1px 4px rgba(99, 127, 146, 0.18);
}
.agent-ledger-review .review-option .option-title {
  font-size: 14px;
  font-weight: 700;
  color: #2c3e50;
  white-space: nowrap;
}
.agent-ledger-review .review-option.is-paid.is-active .option-title {
  color: #389e0d;
}
.agent-ledger-review .review-option.is-unsuccessful.is-active .option-title {
  color: #cf1322;
}
.agent-ledger-review .review-option.is-partial.is-active .option-title {
  color: #d48806;
}
.agent-ledger-review .review-confirm-box {
  width: 100%;
  min-width: 0;
  border: 1px solid #e6edf2;
  border-radius: 6px;
  background: #fafcfd;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
}
.agent-ledger-review .review-confirm-box .confirm-title {
  font-size: 15px;
  font-weight: 700;
  color: #637f92;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f5f9;
}
.agent-ledger-review .review-confirm-box .paid-review-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.agent-ledger-review .review-confirm-box .paid-review-fields .ant-form-item {
  min-width: 0;
}
.agent-ledger-review .review-confirm-box .confirm-actions {
  margin-top: auto;
  padding-top: 8px;
  display: flex;
  justify-content: flex-end;
}
.agent-ledger-review .order-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.agent-ledger-review .receipt-preview {
  text-align: center;
}
.agent-ledger-review .receipt-preview img {
  max-width: 100%;
  max-height: 360px;
  object-fit: contain;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
@media (max-width: 900px) {
  .agent-ledger-review .review-split {
    flex-direction: column;
  }
  .agent-ledger-review .review-decision-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 0 0 12px;
  }
  .agent-ledger-review .review-options {
    width: 100%;
    flex-direction: column;
  }
  .agent-ledger-review .review-option {
    width: 100%;
  }
  .agent-ledger-review .paid-review-fields {
    grid-template-columns: 1fr;
  }
}

.agent-ledger-review {
  min-height: auto;
  padding: 20px;
  background: #f8fafc;
}
.agent-ledger-review .details-header {
  padding: 16px 20px 13px;
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}
.agent-ledger-review .details-header .header-title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.agent-ledger-review .details-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.agent-ledger-review .detail-card {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}
.agent-ledger-review .payment-summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 13px;
  border-bottom: 1px solid #f1f5f9;
}
.agent-ledger-review .payment-summary-header .header-title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.agent-ledger-review .payment-summary-header .ant-tag {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  margin: 0;
  padding: 3px 11px;
  border: 1px solid currentColor !important;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px currentColor;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
}
.agent-ledger-review .section-heading {
  padding: 16px 20px 13px;
  border-bottom: 1px solid #f1f5f9;
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.agent-ledger-review .panel-content,
.agent-ledger-review .order-tags,
.agent-ledger-review .receipt-preview {
  padding: 20px;
}
.agent-ledger-review .orders-inline {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-top: 1px dashed #e2e8f0;
}
.agent-ledger-review .orders-inline .orders-inline-title {
  flex: 0 0 auto;
  color: #53657f;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.agent-ledger-review .orders-inline .order-tags {
  padding: 0;
}
.agent-ledger-review .orders-inline .order-tags .ant-tag {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  margin: 0;
  padding: 3px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #075dc5;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}
.agent-ledger-review .info-value .ant-tag {
  display: inline-flex;
  align-items: center;
  min-height: 25px;
  margin: 0;
  padding: 3px 10px;
  border: 1px solid currentColor !important;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px currentColor;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
}
.agent-ledger-review .pending-status-badge {
  border-color: #d97706 !important;
  background: #fffbeb !important;
  color: #b45309 !important;
  box-shadow: inset 0 0 0 1px rgba(217, 119, 6, 0.2) !important;
}
.agent-ledger-review .panel-content .info-label {
  margin-bottom: 4px;
  color: #53657f;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.agent-ledger-review .panel-content .info-value {
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}
.agent-ledger-review .review-decision-card .ant-form {
  padding: 0 20px 20px;
}
.agent-ledger-review .review-decision-header .section-heading {
  border-bottom: none;
}
.agent-ledger-review .review-option,
.agent-ledger-review .review-confirm-box {
  border-color: #e2e8f0;
  border-radius: 10px;
}
.agent-ledger-review .review-option.is-active {
  border-color: #075dc5;
  background: aliceblue;
  box-shadow: 0 1px 4px rgba(7, 93, 197, 0.16);
}
.agent-ledger-review .review-confirm-box {
  background: #f8fafc;
  border-top-color: #f1f5f9;
}
@media (max-width: 768px) {
  .agent-ledger-review {
    padding: 12px;
  }
  .agent-ledger-review .panel-content,
  .agent-ledger-review .order-tags,
  .agent-ledger-review .receipt-preview,
  .agent-ledger-review .review-decision-card .ant-form {
    padding: 16px;
  }
  .agent-ledger-review .orders-inline {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PendingPaymentVerifications/AgentLedgerPaymentDetails.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,+BAAA;EACA,uBAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAIE;EACE,YAAA;EACA,uBAAA;AAFJ;AAII;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAFN;AAIM;EACE,uBAAA;EACA,8BAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAFR;AAKM;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAHR;AAMM;EACE,uBAAA;EACA,gBAAA;AAJR;AAMQ;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AAJV;AAWI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AATN;AAYI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAVN;AAcE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAbJ;AAeI;EACE,cAAA;EACA,SAAA;AAbN;AAiBE;EACE,SAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;AAfJ;AAkBE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iFACE;AAjBN;AAqBI;EACE,qBAAA;AAnBN;AAsBI;EACE,qBAAA;EACA,mBAAA;EACA,8CAAA;AApBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AArBN;AAwBI;EACE,cAAA;AAtBN;AAyBI;EACE,cAAA;AAvBN;AA0BI;EACE,cAAA;AAxBN;AA4BE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA1BJ;AA4BI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA1BN;AA6BI;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AA3BN;AA6BM;EACE,YAAA;AA3BR;AA+BI;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AA7BN;AAiCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA/BJ;AAkCE;EACE,kBAAA;AAhCJ;AAkCI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAhCN;AAoCE;EACE;IACE,sBAAA;EAlCJ;EAqCE;IACE,uBAAA;IACA,sBAAA;IACA,iBAAA;EAnCJ;EAsCE;IACE,WAAA;IACA,sBAAA;EApCJ;EAuCE;IACE,WAAA;EArCJ;EAwCE;IACE,0BAAA;EAtCJ;AACF;;AA2CA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAxCF;AA0CE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;AAxCJ;AA0CI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAxCN;AA4CE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AA5CJ;AA8CI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA5CN;AA+CI;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,yCAAA;EACA,oBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA7CN;AAiDE;EACE,uBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA/CJ;AAkDE;;;EAGE,aAAA;AAhDJ;AAmDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;AAjDJ;AAmDI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAjDN;AAoDI;EACE,UAAA;AAlDN;AAoDM;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAlDR;AAuDE;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,yCAAA;EACA,oBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArDJ;AAwDE;EACE,gCAAA;EACA,8BAAA;EACA,yBAAA;EACA,6DAAA;AAtDJ;AA0DI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAxDN;AA2DI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAzDN;AA6DE;EACE,oBAAA;AA3DJ;AA8DE;EACE,mBAAA;AA5DJ;AA+DE;;EAEE,qBAAA;EACA,mBAAA;AA7DJ;AAgEE;EACE,qBAAA;EACA,qBAAA;EACA,4CAAA;AA9DJ;AAiEE;EACE,mBAAA;EACA,yBAAA;AA/DJ;AAkEE;EAvLF;IAwLI,aAAA;EA/DF;EAiEE;;;;IAIE,aAAA;EA/DJ;EAkEE;IACE,uBAAA;IACA,sBAAA;IACA,QAAA;IACA,aAAA;EAhEJ;AACF","sourcesContent":[".agent-ledger-review {\n  background: #ffffff;\n  min-height: calc(100vh - 184px);\n  padding: 16px 24px 32px;\n\n  .details-header {\n    padding: 10px 24px;\n    background: #f0f4f7;\n    border-radius: 4px;\n    margin-bottom: 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n    .header-content {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    .header-title {\n      font-size: 16px;\n      font-weight: 700;\n      color: #637f92;\n    }\n  }\n\n  .ant-collapse {\n    border: none;\n    background: transparent;\n\n    > .ant-collapse-item {\n      border: none !important;\n      background: #fff;\n      margin-bottom: 10px;\n      border-radius: 4px;\n      overflow: hidden;\n\n      > .ant-collapse-header {\n        height: 40px !important;\n        background: #f0f4f7 !important;\n        border: none !important;\n        font-weight: 700 !important;\n        font-size: 16px;\n        line-height: 16px !important;\n        color: #637f92 !important;\n        padding: 12px 24px;\n        display: flex;\n        align-items: center;\n      }\n\n      .ant-collapse-arrow {\n        border: 1px solid #637f92;\n        background: #637f92;\n        border-radius: 50%;\n        color: white !important;\n        width: 15px;\n        height: 15px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 10px !important;\n      }\n\n      > .ant-collapse-content {\n        border: none !important;\n        background: #fff;\n\n        > .ant-collapse-content-box {\n          padding: 20px 24px;\n          border: 1px solid #f0f4f7;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  .panel-content {\n    .info-label {\n      color: #637f92;\n      font-size: 13px;\n      margin-bottom: 4px;\n    }\n\n    .info-value {\n      color: #2c3e50;\n      font-size: 15px;\n      font-weight: 600;\n      word-break: break-word;\n    }\n  }\n\n  .review-split {\n    display: flex;\n    gap: 20px;\n    align-items: stretch;\n  }\n\n  .review-decision-header {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    padding: 0 0 14px;\n\n    .section-heading {\n      flex: 0 0 auto;\n      margin: 0;\n    }\n  }\n\n  .review-options {\n    flex: 1;\n    display: flex;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .review-option {\n    flex: 0 1 auto;\n    min-width: 0;\n    text-align: center;\n    background: #fff;\n    border: 1px solid #e6edf2;\n    border-radius: 6px;\n    padding: 8px 14px;\n    font-size: 13px;\n    line-height: 18px;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease,\n      background 0.15s ease;\n\n    &:hover {\n      border-color: #637f92;\n    }\n\n    &.is-active {\n      border-color: #637f92;\n      background: #f0f4f7;\n      box-shadow: 0 1px 4px rgba(99, 127, 146, 0.18);\n    }\n\n    .option-title {\n      font-size: 14px;\n      font-weight: 700;\n      color: #2c3e50;\n      white-space: nowrap;\n    }\n\n    &.is-paid.is-active .option-title {\n      color: #389e0d;\n    }\n\n    &.is-unsuccessful.is-active .option-title {\n      color: #cf1322;\n    }\n\n    &.is-partial.is-active .option-title {\n      color: #d48806;\n    }\n  }\n\n  .review-confirm-box {\n    width: 100%;\n    min-width: 0;\n    border: 1px solid #e6edf2;\n    border-radius: 6px;\n    background: #fafcfd;\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: column;\n\n    .confirm-title {\n      font-size: 15px;\n      font-weight: 700;\n      color: #637f92;\n      margin-bottom: 16px;\n      padding-bottom: 10px;\n      border-bottom: 1px solid #f1f5f9;\n    }\n\n    .paid-review-fields {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 16px;\n\n      .ant-form-item {\n        min-width: 0;\n      }\n    }\n\n    .confirm-actions {\n      margin-top: auto;\n      padding-top: 8px;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .order-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .receipt-preview {\n    text-align: center;\n\n    img {\n      max-width: 100%;\n      max-height: 360px;\n      object-fit: contain;\n      border: 1px solid #f0f0f0;\n      border-radius: 4px;\n    }\n  }\n\n  @media (max-width: 900px) {\n    .review-split {\n      flex-direction: column;\n    }\n\n    .review-decision-header {\n      align-items: flex-start;\n      flex-direction: column;\n      padding: 0 0 12px;\n    }\n\n    .review-options {\n      width: 100%;\n      flex-direction: column;\n    }\n\n    .review-option {\n      width: 100%;\n    }\n\n    .paid-review-fields {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n// Flat card layout aligned with the current payment and refund detail pages.\n.agent-ledger-review {\n  min-height: auto;\n  padding: 20px;\n  background: #f8fafc;\n\n  .details-header {\n    padding: 16px 20px 13px;\n    margin-bottom: 16px;\n    border: 1px solid #e2e8f0;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n\n    .header-title {\n      color: #0f172a;\n      font-size: 16px;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n    }\n  }\n\n  .details-content {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .detail-card {\n    overflow: hidden;\n    border: 1px solid #e2e8f0;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  }\n\n  .payment-summary-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 16px 20px 13px;\n    border-bottom: 1px solid #f1f5f9;\n\n    .header-title {\n      color: #0f172a;\n      font-size: 16px;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n    }\n\n    .ant-tag {\n      display: inline-flex;\n      align-items: center;\n      min-height: 26px;\n      margin: 0;\n      padding: 3px 11px;\n      border: 1px solid currentColor !important;\n      border-radius: 999px;\n      box-shadow: inset 0 0 0 1px currentColor;\n      font-size: 13px;\n      font-weight: 600;\n      line-height: 18px;\n      white-space: nowrap;\n    }\n  }\n\n  .section-heading {\n    padding: 16px 20px 13px;\n    border-bottom: 1px solid #f1f5f9;\n    color: #0f172a;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n  }\n\n  .panel-content,\n  .order-tags,\n  .receipt-preview {\n    padding: 20px;\n  }\n\n  .orders-inline {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 16px 20px;\n    border-top: 1px dashed #e2e8f0;\n\n    .orders-inline-title {\n      flex: 0 0 auto;\n      color: #53657f;\n      font-size: 13px;\n      font-weight: 600;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n    }\n\n    .order-tags {\n      padding: 0;\n\n      .ant-tag {\n        display: inline-flex;\n        align-items: center;\n        min-height: 26px;\n        margin: 0;\n        padding: 3px 10px;\n        border: 1px solid #bfdbfe;\n        border-radius: 999px;\n        background: #eff6ff;\n        color: #075dc5;\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 18px;\n      }\n    }\n  }\n\n  .info-value .ant-tag {\n    display: inline-flex;\n    align-items: center;\n    min-height: 25px;\n    margin: 0;\n    padding: 3px 10px;\n    border: 1px solid currentColor !important;\n    border-radius: 999px;\n    box-shadow: inset 0 0 0 1px currentColor;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 17px;\n  }\n\n  .pending-status-badge {\n    border-color: #d97706 !important;\n    background: #fffbeb !important;\n    color: #b45309 !important;\n    box-shadow: inset 0 0 0 1px rgba(217, 119, 6, 0.2) !important;\n  }\n\n  .panel-content {\n    .info-label {\n      margin-bottom: 4px;\n      color: #53657f;\n      font-size: 13px;\n      font-weight: 500;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n    }\n\n    .info-value {\n      color: #1e293b;\n      font-size: 16px;\n      font-weight: 600;\n    }\n  }\n\n  .review-decision-card .ant-form {\n    padding: 0 20px 20px;\n  }\n\n  .review-decision-header .section-heading {\n    border-bottom: none;\n  }\n\n  .review-option,\n  .review-confirm-box {\n    border-color: #e2e8f0;\n    border-radius: 10px;\n  }\n\n  .review-option.is-active {\n    border-color: #075dc5;\n    background: aliceblue;\n    box-shadow: 0 1px 4px rgba(7, 93, 197, 0.16);\n  }\n\n  .review-confirm-box {\n    background: #f8fafc;\n    border-top-color: #f1f5f9;\n  }\n\n  @media (max-width: 768px) {\n    padding: 12px;\n\n    .panel-content,\n    .order-tags,\n    .receipt-preview,\n    .review-decision-card .ant-form {\n      padding: 16px;\n    }\n\n    .orders-inline {\n      align-items: flex-start;\n      flex-direction: column;\n      gap: 8px;\n      padding: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
